import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/camera2.svg'


const _withScopeId = n => (_pushScopeId("data-v-74b79c16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newgroupchatMessages" }
const _hoisted_2 = { class: "edit__group" }
const _hoisted_3 = { class: "newgroupchatMessages__inputs__wrapper" }
const _hoisted_4 = { class: "group_input_content" }
const _hoisted_5 = { class: "uploade-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "file-placeholder-image"
}, null, -1))
const _hoisted_7 = { class: "newgroupchatMessages__userNetworkContacts__wrapper" }
const _hoisted_8 = { class: "group_selector" }
const _hoisted_9 = { class: "group_selector_inner" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "group_img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "group_selector_inner" }
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = { class: "group_img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "submit_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_text_field, {
      class: "chatbox__search create_group__search",
      modelValue: $setup.searchNetworkUsers,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchNetworkUsers) = $event)),
      label: "Search",
      "prepend-inner-icon": "mdi-magnify",
      variant: "solo-filled",
      "hide-details": "",
      "single-line": "",
      flat: "",
      placeholder: "Search"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_form, {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          rules: $setup.validation,
          ref: "groupFormRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_file_input, {
                  class: "upload_file",
                  variant: "solo-filled",
                  modelValue: $setup.groupAvatar,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.groupAvatar) = $event)),
                  rules: $setup.validation.groupAvatar,
                  accept: "image/*",
                  label: "Group Avatar",
                  onChange: $setup.handleFileChange,
                  "on-click:clear": $setup.onClearGroupAvatar
                }, null, 8, ["modelValue", "rules", "onChange", "on-click:clear"]),
                _createVNode(_component_v_img, {
                  class: "uploaded-img",
                  width: 200,
                  "aspect-ratio": "16/9",
                  cover: "",
                  src: $setup.imageUrl
                }, null, 8, ["src"]),
                _hoisted_6
              ]),
              _createVNode(_component_v_text_field, {
                modelValue: $setup.groupName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.groupName) = $event)),
                rules: $setup.validation.groupName,
                class: "messagechat__message",
                variant: "solo-filled",
                "hide-details": "",
                "single-line": "",
                flat: "",
                label: "Group Name"
              }, null, 8, ["modelValue", "rules"])
            ])
          ]),
          _: 1
        }, 8, ["rules"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_tabs, {
              modelValue: $setup.tab,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => (($setup.tab) = $event)),
                $setup.onTabChange
              ],
              stacked: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: $setup.tabs[0]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, "members " + _toDisplayString(`(${$setup.usersList.length})`), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_v_tab, {
                  value: $setup.tabs[1]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, "workStation " + _toDisplayString(`(${$setup.workStationList.length}) `), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            ($setup.tab === $setup.tabs[0])
              ? (_openBlock(), _createBlock(_component_v_tabs_window, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.usersList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          onClick: ($event: any) => ($setup.toggleCheckboxOnClick(item.id)),
                          class: "group__list"
                        }, [
                          _createVNode(_component_v_checkbox, {
                            color: "#4B4BFF",
                            width: "16px",
                            ripple: false,
                            disabled: $setup.isLoading,
                            modelValue: $setup.isChecked(item),
                            "onUpdate:modelValue": 
                    (value) => $setup.updateSelectedItems(item, value)
                  
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("img", {
                                  src: 
                            $setup.getImagePublicUrl(
                              item?.receiverWorkstation?.user.profileImage
                            )
                              ? $setup.getImagePublicUrl(
                                  item?.receiverWorkstation?.user.profileImage
                                )
                              : require('@/assets/images/user-placeholder.png')
                          ,
                                  alt: "workStation_img"
                                }, null, 8, _hoisted_12)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["status_wrapper", 
                          $setup.isUserOnline(item?.receiverWorkstation?.user?.id)
                            ? 'online'
                            : 'offline'
                        ])
                              }, null, 2),
                              _createElementVNode("span", null, _toDisplayString(`${item?.receiverWorkstation?.user?.firstName} ${item?.receiverWorkstation?.user?.lastName}`), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"])
                        ], 8, _hoisted_10))
                      }), 128)),
                      ($setup.usersList.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "No users found"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($setup.tab === $setup.tabs[1])
              ? (_openBlock(), _createBlock(_component_v_tabs_window, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.workStationList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          onClick: ($event: any) => ($setup.toggleCheckboxOnClick(item.id)),
                          disabled: $setup.isLoading,
                          class: "group__list"
                        }, [
                          _createVNode(_component_v_checkbox, {
                            color: "#4B4BFF",
                            width: "16px",
                            ripple: false,
                            disabled: $setup.isLoading,
                            modelValue: $setup.isChecked(item),
                            "onUpdate:modelValue": 
                    (value) => $setup.updateSelectedItems(item, value)
                  
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("img", {
                                  src: 
                            $setup.getImagePublicUrl(
                              item?.receiverWorkstation.profileImage
                            )
                              ? $setup.getImagePublicUrl(
                                  item?.receiverWorkstation.profileImage
                                )
                              : require('@/assets/images/user-placeholder.png')
                          ,
                                  alt: "workStation_img"
                                }, null, 8, _hoisted_17)
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["status_wrapper", 
                          $setup.isUserWorkStationOnline(item?.receiverWorkstation?.id)
                            ? 'online'
                            : 'offline'
                        ])
                              }, null, 2),
                              _createElementVNode("span", null, _toDisplayString(`(${item?.receiverWorkstation?.name})`), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"])
                        ], 8, _hoisted_15))
                      }), 128)),
                      ($setup.workStationList.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " No workStation found "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_v_btn, {
            class: "button button-orange",
            loading: $setup.isLoading,
            onClick: $setup.createNewUserNetWorkGroup
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Create New Group ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ])
    ])
  ]))
}